

var Swal = require('sweetalert2/dist/sweetalert2.js');
var toastr = require('toastr');

module.exports = {
    days_of_week: {
        1: 'Monday', 2: 'Tuesday', 3: 'Wednesday',
        4: 'Thursday', 5: 'Friday', 6: 'Saturday', 7: 'Sunday'
    },

    day_name: function(num) {
        return this.days_of_week[num] || 'Day ' + num;
    },

    notify: function(type, message, options = null) {
        toastr.options = $.extend({
            debug: false,
            newestOnTop: true,
            progressBar: true,
            positionClass: 'toast-bottom-right',
            preventDuplicates: false,
            onclick: null,
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000,
            showEasing: 'swing',
            hideEasing: 'linear',
            showMethod: 'fadeIn',
            hideMethod: 'fadeOut'
        }, options || {});
        toastr[type](message);
    },

    notifyAndReload: function(type, message) {
        sessionStorage.setItem('beautify_flash', JSON.stringify({ type: type, message: message }));
        location.reload();
    },

    notifyAndRedirect: function(type, message, url) {
        sessionStorage.setItem('beautify_flash', JSON.stringify({ type: type, message: message }));
        location.href = url;
    },

    badge: function (str, badge_style = null) {
        if (!str) return null;
        var self = this;

        var renderOne = function (raw) {
            var display = raw.replace(/_/g, ' ').trim();
            var key = raw.trim().toLowerCase();

            var cssClass = badge_style || self._defaultBadgeClass(key);

            return '<span class="badge badge-' + cssClass + '">' + display + '</span>';
        };

        return renderOne(str);
    },

    _defaultBadgeClass: function (key) {
        var map = {
            'inactive': 'danger',
            'pending': 'warning',
            'active': 'success',
            'on_break': 'alternate',
            'draft': 'secondary',
            'approved': 'info',
            'paid': 'success',
            'suspended': 'danger',
        };
        return map[key] || 'primary';
    },


    empty: function(obj){
        if (obj == null) return true;
        if (obj.length > 0)    return false;
        if (obj.length === 0)  return true;
        if (typeof obj !== "object") return true;
        return true;
    },

    slugify: function(string){
        return string
            .toLowerCase()
            .replace(/[^\w ]+/g,'')
            .replace(/ +/g,'_');
    },


    date_time: function (date) {
        if(!date) return '(empty)';
        return moment(date).format('DD MMM, YYYY | h:mm A');
    },

    date_format: function (date) {
        if(!date) return '(empty)';
        return moment(date).format(date_format);
    },

    removeTags: function (str) {
        if ((str===null) || (str==='')) return false;
        str = str.toString();
        return str.replace( /(<([^>]+)>)/ig, '');
    },

    remove_dom: function (elem, data_parent = null){
        elem.css({"background":'#b2bec3', 'transition': 'linear background .3s'}).delay(300).queue(function(){
            $(this).remove();
            if($(data_parent).length){
                $(data_parent).trigger('change')
            }
        });
    },

    highlight: function (elem){
        elem.addClass('highlight')
        setTimeout(function () {
            elem.removeClass('highlight');
        }, 400);
    },

    excerpt: function (str, limit = 40){
        if (!str) return '(empty)';
        str = this.removeTags(str)
        if(str.length > limit){
            var excerpt = str.substring(0, limit);
            return '<span data-toggle="tooltip-light" data-original-title="'+str+'">'+excerpt+'...</span>';
        }else{
            return str;
        }
    },

    loading: function(str = ''){
        return '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> '+str;
    },

    sweetConfirm: function(title, message, callback) {
        if((typeof Swal !== 'undefined')){
            Swal.fire({
                title: title,
                text: (message)?message:'Click ok to proceed!',
                icon: 'warning',
                showCancelButton: true
            }).then((confirmed) => {
                callback(confirmed && confirmed.value == true);
            });
        }else{
            if(confirm(title)){
                callback(true)
            }
        }
    },

    alert: function(title, message) {
        if((typeof Swal !== 'undefined')){
            Swal.fire({
                title: title,
                text: (message)?message:'Click ok to proceed!',
                icon: 'warning',
                showCancelButton: false
            })
        }else{
            alert(message)
        }
    },

    prompt: function (title, message, inputValue, callback, options) {
        inputValue = inputValue || '';
        options = options || {};
        var inputType = options.input || 'text';
        var confirmText = options.confirmButtonText || 'Save';

        if (typeof Swal !== 'undefined') {
            var swalOptions = {
                title: title,
                text: (message) ? message : '',
                icon: options.icon || 'question',
                input: inputType,
                inputValue: inputValue,
                showCancelButton: true,
                confirmButtonText: confirmText
            };
            if (options.inputValidator) {
                swalOptions.inputValidator = options.inputValidator;
            }
            Swal.fire(swalOptions).then(function (result) {
                if (result.value !== undefined && result.value !== null) {
                    callback(result.value.trim());
                }
            });
        } else {
            var val = prompt((message) ? title + '\n' + message : title, inputValue);
            if (val !== null) callback(val.trim());
        }
    },

    initCollapsePersistence: function() {
        $('[data-persist-collapse]').each(function() {
            var $wrapper = $(this);
            var key = 'collapse:' + $wrapper.data('persist-collapse');
            var $target = $wrapper.find('.collapse').first();

            // Restore state
            var saved = localStorage.getItem(key);
            if (saved !== null) {
                if (saved === '1') {
                    $target.addClass('show');
                } else {
                    $target.removeClass('show');
                }
            }

            // Persist on toggle
            $target.on('shown.bs.collapse hidden.bs.collapse', function() {
                localStorage.setItem(key, $target.hasClass('show') ? '1' : '0');
            });
        });
    },

    setItem: function(key, data){
        return localStorage.setItem(key, JSON.stringify(data))
    },

    getItem: function(key){
        try {
            return JSON.parse(localStorage.getItem(key));
        } catch (e) {
            return false;
        }
    },

    currency: function(amount, options = {}) {
        var showSymbol = options.showSymbol !== undefined ? options.showSymbol : true;
        var decimals = options.decimals !== undefined ? options.decimals : (typeof currency_precision !== 'undefined' ? currency_precision : 2);
        var num = parseFloat(amount);
        if (isNaN(num)) num = 0;
        var formatted = num.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
        if (!showSymbol) return formatted;
        return currency_position === 'after' ? formatted + ' ' + currency_symbol : currency_symbol + ' ' + formatted;
    },

    uid: function(length = 6) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
            result += characters.charAt(Math.floor(Math.random() *
            charactersLength));
        }
        return result;
    },

    _filterStorageKey: function() {
        return 'filter_state:' + window.location.pathname;
    },

    _syncFiltersToUrl: function(containerSelector) {
        var params = new URLSearchParams(window.location.search);
        $(containerSelector).find('input, select, textarea').each(function() {
            var $el = $(this);
            var id = $el.attr('id');
            if (!id) return;
            var val = $el.is(':checkbox') ? ($el.prop('checked') ? '1' : '') : $el.val();
            params.delete(id);
            if ($el.is('select[multiple]')) {
                (val || []).forEach(function (v) {
                    if (v) params.append(id, v);
                });
            } else if (val) {
                params.set(id, val);
            }
        });
        var qs = params.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '');
        history.replaceState(null, '', newUrl);
    },

    _loadFiltersFromUrl: function(containerSelector) {
        var params = new URLSearchParams(window.location.search);
        if (params.toString() === '') return false;
        $(containerSelector).find('input, select, textarea').each(function() {
            var $el = $(this);
            var id = $el.attr('id');
            if (!id) return;
            var val = params.get(id);
            if ($el.is('select[multiple]')) {
                var vals = params.getAll(id);
                if (vals.length) {
                    $el.val(vals);
                    $el.trigger('change');
                }
            } else if (val !== null) {
                if ($el.is(':checkbox')) {
                    $el.prop('checked', val === '1');
                } else {
                    $el.val(val);
                }
                $el.trigger('change');
            }
        });
        return true;
    },

    _clearUrlParams: function() {
        history.replaceState(null, '', window.location.pathname);
    },

    saveFilters: function(containerSelector) {
        var state = {};
        $(containerSelector).find('input, select, textarea').each(function() {
            var $el = $(this);
            var id = $el.attr('id');
            if (!id) return;
            if ($el.is(':checkbox')) {
                state[id] = $el.prop('checked');
            } else if ($el.is('.select2')) {
                state[id] = $el.val();
            } else {
                state[id] = $el.val();
            }
        });
        // Also save collapse state
        var $collapse = $(containerSelector);
        if ($collapse.hasClass('collapse')) {
            state['__collapse_open'] = $collapse.hasClass('show');
        }
        localStorage.setItem(this._filterStorageKey(), JSON.stringify(state));
        if (this._urlPersistEnabled(containerSelector)) {
            this._syncFiltersToUrl(containerSelector);
        }
    },

    _urlPersistEnabled: function(containerSelector) {
        return $(containerSelector).attr('data-persist-url') !== 'false';
    },

    restoreFilters: function(containerSelector) {
        var loadedFromUrl = this._urlPersistEnabled(containerSelector) ? this._loadFiltersFromUrl(containerSelector) : false;

        if (!loadedFromUrl) {
            var raw = localStorage.getItem(this._filterStorageKey());
            if (!raw) return;
            try {
                var state = JSON.parse(raw);
            } catch (e) {
                return;
            }
            $(containerSelector).find('input, select, textarea').each(function() {
                var $el = $(this);
                var id = $el.attr('id');
                if (!id || !(id in state)) return;
                if ($el.is(':checkbox')) {
                    $el.prop('checked', state[id]);
                } else {
                    $el.val(state[id]);
                }
                $el.trigger('change');
            });
        }

        this._syncCollapseState(containerSelector, loadedFromUrl);
    },

    _syncCollapseState: function(containerSelector, loadedFromUrl) {
        var $container = $(containerSelector);
        if (!$container.hasClass('collapse')) return;

        var hasValue = false;
        $container.find('input, select, textarea').each(function() {
            var $el = $(this);
            if ($el.is(':checkbox')) {
                if ($el.prop('checked')) hasValue = true;
            } else if ($el.val() !== null && $el.val() !== '') {
                hasValue = true;
            }
        });

        if (hasValue) {
            $container.collapse('show');
            return;
        }

        if (loadedFromUrl) return;

        var raw = localStorage.getItem(this._filterStorageKey());
        if (!raw) return;
        try {
            var state = JSON.parse(raw);
        } catch (e) {
            return;
        }
        if ('__collapse_open' in state) {
            if (state['__collapse_open']) {
                $container.collapse('show');
            } else {
                $container.collapse('hide');
            }
        }
    },

    clearFilters: function(containerSelector) {
        var $container = $(containerSelector);
        $container.find('input, select, textarea').each(function() {
            var $el = $(this);
            if ($el.is(':checkbox')) {
                $el.prop('checked', false);
            } else if ($el.is('.select2')) {
                $el.val(null).trigger('change');
            } else {
                $el.val('');
            }
        });

        var state = {};
        $container.find('input, select, textarea').each(function() {
            var id = $(this).attr('id');
            if (id) state[id] = '';
        });
        if ($container.hasClass('collapse')) {
            state['__collapse_open'] = false;
        }
        localStorage.setItem(this._filterStorageKey(), JSON.stringify(state));
        if (this._urlPersistEnabled(containerSelector)) {
            this._clearUrlParams();
        }
        $container.trigger('filtersCleared');
    },
    /**
     *
     * @param {url_path} url_path url path after base_url
     */
    redirect: function(url_path){
        window.location.replace(url_path);
    },

    array_search: function(array, attr, value) {
        if( typeof array  == 'undefined') return -1;
        for(var i = 0; i < array.length; i += 1) {
            if(array[i][attr] == value) {
                return i;
            }
        }
        return -1;
    },

    isValid: function(divObj, controls){
        let valid = true;
        $(divObj).find('.form-control').each(function(i, obj) {
            obj.checkValidity()
            if(obj.validity.valid == false){
                valid = false;
            }
        });
        return valid;
    },

    validate: function(divObj, controll_class){
        $(divObj).find(controll_class).each(function(i, obj) {
            console.log("Validating...")
            console.log("AB:",obj.validity.valid);
            obj.checkValidity()
            if(obj.validity.valid == false){
                if($(obj).parent().find('.invalid-feedback').length){
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage).removeClass('d-block').addClass('d-block');
                }else{
                    $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback d-block">'+obj.validationMessage+'</em>');
                }
            }
        });
    },

    realTimeValidate: function(divObj){
        $(divObj).find('.form-control').each(function(i, obj) {

            $(document).on('input', obj, function(e) {
                obj.checkValidity()
                if(obj.validity.valid == true){
                    $(obj).parent().find('.invalid-feedback').removeClass('d-block');
                    return true;
                }
                if($(obj).parent().find('.invalid-feedback').length){
                    $(obj).parent().find('.invalid-feedback').text(obj.validationMessage).removeClass('d-block').addClass('d-block');
                }else{
                    $(obj).parent().append('<em id="'+$(obj).attr('name')+'-error" class="error invalid-feedback d-block">'+obj.validationMessage+'</em>');
                }
            });
        });
    },

    /**
     * @param {url || html element containing href attr} any
     *
     */
     ajaxModal: function(elem){
        let elemIsString = false;
        if( typeof elem === 'string' || elem instanceof String ){
            //passed string
            var link = elem;
            elemIsString = true;
        }else{
            if($(elem).length){
                var link = $(elem).attr('href');

                var _loadable_div = ['a', 'button', 'input'];
                if( _loadable_div.includes($(elem).prop("tagName").toLowerCase()) ){
                    var str_loading = '<span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Loading...';
                    if($(elem).html() != str_loading){
                        var elem_content = $(elem).html();
                    }
                    $(elem).html(str_loading);
                }
            }
        }

        $.ajax({
            url: link,
            type: 'GET',
            success: function(data) {
                // if ajax-modal req response is JSON object shoiw toast notification
                if(typeof data == 'object'){
                    toastr.options = {
                        "debug": false,
                        "newestOnTop": true,
                        "progressBar": true,
                        "positionClass": "toast-bottom-right",
                        "preventDuplicates": false,
                        "onclick": null,
                        "showDuration": "300",
                        "hideDuration": "1000",
                        "timeOut": "5000",
                        "extendedTimeOut": "1000",
                        "showEasing": "swing",
                        "hideEasing": "linear",
                        "showMethod": "fadeIn",
                        "hideMethod": "fadeOut"
                    };
                    toastr[data.status](data.message);
                    return false;
                }

                if(!elemIsString){
                    if($(elem).length){
                        setTimeout(() => {
                            $(elem).html(elem_content);
                        }, 500);
                    }
                }

                $('#myModal').html(data).modal();
                $('#myModal').attr('data-source', link);

                $('[data-toggle="tooltip"]').tooltip();
                $('[data-toggle="tooltip-light"]').tooltip({
                    template: '<div class="tooltip tooltip-light"><div class="tooltip-inner"></div></div>'
                });

                $('#myModal').find('.select2').select2({
                    theme:"bootstrap4",
                    width: '100%'
                });
                $('#myModal').find('.select2-tag').select2({
                    theme:"bootstrap4",
                    width: '100%',
                    tags: true,
                });

                $('#myModal').find('.random').val(beautify.uid(7));
                $('#myModal').find('[data-toggle=toggle]').bootstrapToggle();

                $('#myModal .datepicker').datepicker({
                    todayHighlight: true,
                    autoclose: true,
                    format: 'yyyy-mm-dd',
                    weekStart: 1
                }).trigger('change');

                mdtimepicker('#myModal .timepicker', {
                    timeFormat: 'hh:mm:ss.000',
                    format: 'h:mm tt',
                    theme: 'teal',
                    hourPadding: true
                });

                $('#myModal').find('.decimal, .float, .double, .percentage').attr('autocomplete', 'off');

                /**
                 * Barcode
                 * Default Format: CODE128
                 *
                 * USES: <canvas class="barcode" format="CODE128" value="123456789"></canvas>
                 */
                 $('#myModal').find('.barcode').each(function(i, elem){
                    console.log( 'generate barcode' );
                    $(elem).JsBarcode(
                        $(elem).attr('value'),
                        {
                            format: ($(elem).attr('format')) ? $(elem).attr('format') : 'CODE128',
                            lineColor: "#424b77",
                            displayValue: true,
                            fontSize: 12,
                            height:60,
                        }
                    );
                });
            },
            error: function(){

                toastr.options = {
                    "debug": false,
                    "newestOnTop": true,
                    "progressBar": true,
                    "positionClass": "toast-bottom-right",
                    "preventDuplicates": false,
                    "onclick": null,
                    "showDuration": "300",
                    "hideDuration": "1000",
                    "timeOut": "5000",
                    "extendedTimeOut": "1000",
                    "showEasing": "swing",
                    "hideEasing": "linear",
                    "showMethod": "fadeIn",
                    "hideMethod": "fadeOut"
                };
                toastr['error']('Oops! Something went wrong. Please refresh and try again.');
            }
        });

        if(!elemIsString){
            if($(elem).length){
                setTimeout(() => {
                    $(elem).html(elem_content);
                }, 5000);
            }
        }
    }

}

// Auto-consume flash notification after page reload
$(function () {
    var raw = sessionStorage.getItem('beautify_flash');
    if (raw) {
        sessionStorage.removeItem('beautify_flash');
        var flash = JSON.parse(raw);
        beautify.notify(flash.type, flash.message);
    }

    // Open an ajax-loaded modal from the clicked element's href.
    // Usage: <a data-toggle="ajax-modal" href="{{ route('...form') }}">
    $(document).on('click', '[data-toggle="ajax-modal"], .ajax-modal', function (e) {
        e.preventDefault();
        beautify.ajaxModal(this);
    });

    beautify.initCollapsePersistence();
});
